import { gql } from '@apollo/client'

export default gql(`
    mutation($id: ID! $name: String! $media: [ID] $isDisabled: Boolean $project: String) {
        updateAuthor(
            input: {
                id: $id
                name: $name
                isDisabled: $isDisabled
                media: $media
            }
            project: $project
        ) {
            id
            name
            assetCount
            isDisabled
            isTransferring
            isError
            media {
                id
                name
                fileName
                aspectRatio {
                    aspectRatio
                    ratio
                    title          
                    resolutions {
                      url
                    }
                }
                settings {
                    aspectRatio
                    outputFormat
                    fileName
                    x1
                    y1
                    x2
                    y2          
                }
            }
        }
    }`
)
